import { render, staticRenderFns } from "./OrderFuturesRecords.vue?vue&type=template&id=5e0f22e3&scoped=true"
import script from "./OrderFuturesRecords.vue?vue&type=script&lang=js"
export * from "./OrderFuturesRecords.vue?vue&type=script&lang=js"
import style0 from "./OrderFuturesRecords.vue?vue&type=style&index=0&id=5e0f22e3&prod&lang=scss&scoped=true"
import style1 from "./OrderFuturesRecords.vue?vue&type=style&index=1&id=5e0f22e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f22e3",
  null
  
)

export default component.exports